const videoLoader = {

	$window: $(window),
	supports: 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window  && 'intersectionRatio' in window.IntersectionObserverEntry.prototype,
	obsOpt: {
		rootMargin: '0px 0px 75% 0px',
		threshold: 0
	},
	observer: '',

	init() {
		if (this.supports) {
			videoLoader.observer = new IntersectionObserver(videoLoader.loadVideo, videoLoader.obsOpt);
		}
		
		$('[data-video-src]').each(function() {

			if (videoLoader.supports) {
				videoLoader.observer.observe($(this)[0]);
			}
		});

		if (!this.supports) {
			// Fallback: just load all of the videos
			videoLoader.loadAllVideos();
		}
	},

	loadVideo(entries, obs) {

		entries.forEach(function(entry) {
			let isVideo = $(entry.target).is('video');

			if (entry.isIntersecting && isVideo) {
				videoLoader.loadVideoSources(entry.target);
				obs.unobserve(entry.target);
			}
		});
	},
	loadVideoSources(el) {
		let path = $(el).attr('data-video-src') ? $(el).attr('data-video-src') : false;

		if (path) {
			let mp4 = $(el).attr('data-video-src') + '.mp4';
			let src = '<source src="' + mp4 + '" type="video/mp4"></source>';

			$(el).html(src);
		}
	},
	loadAllVideos() {
		$('[data-video-src]').each(function() {

			if ($(this).is('video')) {
				videoLoader.loadVideoSources($(this));
			}
		});
	},
	bindUIActions() {

		// $('body').on('forcevideoload', function() {
		//   loadAllVideos();
		// });
		
		// $('body').on('initvideoload', function() {
		//   init();
		// });
		
		// $('body').trigger('initvideoload');
	}
};

export { videoLoader };
